/**
 * Categorias de error GraphQL de Magento que implican que el token de cliente
 * que enviamos ya no sirve.
 *
 * Vive en su propio modulo, sin dependencias, por dos razones: lo importan
 * tanto graphqlFetch como use-query sin generar un ciclo, y mockear
 * graphqlFetch en un test no deja la lista en undefined.
 *
 * Magento emite `graphql-authorization` para permisos y
 * `graphql-authentication` para token vencido o ilegible: desde 2.4.8 el
 * AuthorizationRequestValidator de CustomerGraphQl valida el header en toda
 * request, asi que estas categorias llegan tambien en queries publicas.
 */
export const AUTH_ERROR_CATEGORIES = [
    'graphql-authorization',
    'graphql-authentication'
]

/**
 * El carrito de invitado, usado ya con el token del cliente, responde
 * graphql-authorization. No es un token vencido: pasa en el login del checkout,
 * antes de que mergeCarts reemplace ese id.
 */
export function isCartOwnershipError(message?: string): boolean {
    return /cannot perform operations on cart|no puede realizar operaciones en el carrito/i.test(
        message ?? ''
    )
}

export function isExpiredCustomerSessionError(error: {
    message?: string
    extensions?: { category?: string }
}): boolean {
    const category = error.extensions?.category
    if (!category || !AUTH_ERROR_CATEGORIES.includes(category)) {
        return false
    }

    return !isCartOwnershipError(error.message)
}
